/* eslint-disable */
import { adminApi } from '../../helpers/ApiHelper';
import AppSubmissionApproval from '../../model/appManagement/admin/AppSubmissionApproval';
import AppSubmissionLog from '../../model/appManagement/admin/AppSubmissionLog';
import ErrorMessage from '../../model/services/ErrorMessage';
import App from '../../model/appManagement/App';
import AppStoreListingApproval from '../../model/appManagement/admin/AppStoreListingApproval';
import AppStoreListingSubmissionLog from '../../model/appManagement/admin/AppStoreListingSubmissionLog';
import PagedResult from '../../model/utility/PagedResult';
import GetAppsAdminRequest from '../../model/appManagement/admin/GetAppsAdminRequest';

const undefinedResponse = () => {
    let errorMessage: ErrorMessage = { errorMessage: 'Undefined response' };
    return errorMessage;
};

const updateAppSubmission = async (appId: string, appSubmissionApproval: AppSubmissionApproval) => {
    return await adminApi
        .post<boolean, string>(`Apps/${appId}/AppSubmission`, appSubmissionApproval)
        .then((response) => {
            if (response.data !== undefined) {
                if (response.ok) {
                    return response.data;
                } else {
                    let errorMessage: ErrorMessage = { errorMessage: response.data };
                    return errorMessage;
                }
            } else {
                return undefinedResponse();
            }
        });
};

const getAllApps = async () => {
    return await adminApi.get<App[], string>('Apps').then((response) => {
        if (response.data !== undefined) {
            if (response.ok) {
                return response.data;
            } else {
                let errorMessage: ErrorMessage = { errorMessage: response.data };
                throw errorMessage;
            }
        } else {
            throw undefinedResponse();
        }
    });
};

const getAppsByPage = async ({ pageNumber, pageSize, searchFilter }: GetAppsAdminRequest) => {
    return await adminApi
        .get<PagedResult<App>, string>('Apps/GetByPage', {
            search: searchFilter,
            pageSize: pageSize,
            pageNumber: pageNumber,
        })
        .then((response) => {
            if (response.data !== undefined) {
                if (response.ok) {
                    return response.data;
                } else {
                    let errorMessage: ErrorMessage = { errorMessage: response.data };
                    throw errorMessage;
                }
            } else {
                throw undefinedResponse();
            }
        });
};

const submitListingApproval = async (approval: AppStoreListingApproval) => {
    return await adminApi
        .put<AppStoreListingApproval[], string>(`Apps/${approval.appId}/SubmitApproval`, approval)
        .then((response) => {
            if (response.data !== undefined) {
                if (response.ok) {
                    return response.data;
                } else {
                    let errorMessage: ErrorMessage = { errorMessage: response.data };
                    throw errorMessage;
                }
            } else {
                throw undefinedResponse();
            }
        });
};

const getAppStoreListingSubmissionLogs = async (appId: string) => {
    return await adminApi
        .get<AppStoreListingSubmissionLog[], string>(`Apps/${appId}/SubmissionLogs`)
        .then((response) => {
            if (response.data !== undefined) {
                if (response.ok) {
                    return response.data;
                } else {
                    let errorMessage: ErrorMessage = { errorMessage: response.data };
                    throw errorMessage;
                }
            } else {
                throw undefinedResponse();
            }
        });
};

export default {
    updateAppSubmission,
    getAllApps,
    submitListingApproval,
    getAppStoreListingSubmissionLogs,
    getAppsByPage,
};
